
<script setup>
    // child component of AlternativeAddress.vue. Gets info to show from parent, as well as
    // if it's a Lieferadresse or Rechnungsadresse. Saving is done parent component with an emit.

    import { ref } from 'vue';

    const props = defineProps(['alternativeAddressInfo', 'addressType']);
    defineEmits(['switch-to-edit', 'delete-data']);

    const alternativeAddressInfo = ref(props.alternativeAddressInfo);

</script>

<template>
    <div class="well">
        <div class="row">
            <div class="col" v-if="alternativeAddressInfo">
                <p>
                    {{ alternativeAddressInfo.name2 }}<br>
                    {{ alternativeAddressInfo.name1 }}<br>
                    {{ alternativeAddressInfo.strasse }}<br>
                    {{ alternativeAddressInfo.plz }} {{ alternativeAddressInfo.ort }}<br>
                    {{ alternativeAddressInfo.land }}<br>
                </p>
            </div>
            <div class="table-footer right">
                <button class="btn btn-link footer-button" @click="$emit('switch-to-edit')">
                    Bearbeiten <i class="fas fa-lg fa-pencil-alt"></i>
                </button>
                <button class="btn btn-link footer-button" type="submit" data-bs-toggle="modal" data-bs-target="#testmodal" >
                    Löschen <i class="fas fa-lg fa-times"></i>
                </button>
            </div>

        </div>
    </div>

    <div class="modal" id="testmodal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Alternative {{ addressType }} löschen</h4>
                    <button type="button" class="button-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p>Sind Sie sich wirklich sicher, dass Sie Ihre alternative {{ addressType }} wirklich löschen wollen?</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Abbrechen</button>
                    <button type="button" data-bs-dismiss="modal" @click="$emit('delete-data')" class="btn btn-primary">Adresse löschen</button>
                </div>
            </div>
        </div>
    </div>

</template>
